// extracted by mini-css-extract-plugin
export default {"list":"ReferralsList_list__87swx","item":"ReferralsList_item__uafPG","item_name":"ReferralsList_item_name__NDOle","item_amount":"ReferralsList_item_amount__nfRbF"};